import { isPlatformBrowser } from "@angular/common";
import {
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
} from "@angular/core";
import { ParamFilters } from "@app/models/filtermodels/ParamFilters";
import { Partner } from "@app/models/partner/IPartner";
import { HotelFiltersService } from "@app/services/hotelfilters.service";
import { Subject, takeUntil } from "rxjs";
@Component({
    selector: "clever-direktflug",
    templateUrl: "./direktflug.component.html",
    styleUrls: ["./direktflug.component.scss"],
    standalone: false,
})
export class DirektflugComponent implements OnInit, OnDestroy {
    protected unsubscribe$ = new Subject();
    @Input() mode: string;
    @Input() partner: Partner;
    isBrowser: boolean = false;
    direktflug: string = "";

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    selectStops(stop) {
        if (this.direktflug === stop) {
            this.direktflug = "";
        } else {
            this.direktflug = stop;
        }
        if (this.direktflug === "N") {
            this.hotelService.directness("N", true);
        } else if (this.direktflug?.length > 0) {
            this.hotelService.stopover(this.direktflug, true);
        } else {
            this.hotelService.directness("", true); // automaticly stopover is ''
        }
        this.cdr.markForCheck();
    }

    protected initFilterSub(): void {
        this.hotelService.getfilters$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((filter: ParamFilters) => {
                this.initDatas(filter);
            });
    }

    protected initDatas(filter) {
        if (filter?.flight?.directness === "N") {
            this.direktflug = "N";
        } else if (filter?.flight?.stopover?.length > 0) {
            this.direktflug = filter.flight.stopover;
        } else {
            this.direktflug = "";
        }
        this.cdr.markForCheck();
    }
}
